import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import { Card } from 'reactstrap';

import config from '../../config';
import AdminHeader from '../../components/header/AdminHeader';
import { convertToMask, fileDownload } from '../../utils/common';

import { useUserDetails } from '../../store/slices/authSlice';
import { setCallingModalOpen, setSidebarType } from '../../store/slices/commonSlice';
import { setCallId, setCallNumber, setScreenType } from '../../store/slices/dialSlice';
import { crmInformation, previewCall, previewCallList } from '../../store/slices/callingSlice';

const LeadPreview = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useUserDetails();

  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [headerFields, setHeaderFields] = useState({
    default: [],
    crm_fields: []
  });

  const onPrevieweCall = async (value) => {
    try {
      const payload = {
        crm_id: value?.crm_id,
        destination_number: value?.destination_number
      };
      const response = await dispatch(previewCall(payload)).unwrap();
      if (response?.data) {
        const manualHangup = process.env.REACT_APP_MANUAL_CALL_HANGUP === 'true';
        dispatch(setCallId(response?.data?.origination_uuid));
        dispatch(setCallNumber(value?.destination_number));
        dispatch(setCallingModalOpen(true));
        getCrmDetails(response.data);
        if (!manualHangup) {
          dispatch(setScreenType('LIVE_CALL'));
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const getCrmDetails = async (data) => {
    try {
      const paylaod = {
        crm_id: data?.crm_id,
        unique_id: data?.unique_id
      };
      const resposne = await dispatch(crmInformation(paylaod)).unwrap();
      if (resposne) {
        dispatch(setSidebarType('CRM'));
        navigate('/crm');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onLeadPreviewListGet = async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(previewCallList()).unwrap();
      if (response) {
        setHeaderFields({
          ...headerFields,
          default: response?.header_fields?.default || [],
          crm_fields:
            [
              { label: 'Actions', name: 'actions' },
              ...(response?.header_fields?.crm_fields || [])
            ] || []
        });
        setReportData(response?.data || []);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  useEffect(() => {
    onLeadPreviewListGet();

    const interval = setInterval(() => {
      if (!isLoading) {
        onLeadPreviewListGet();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <AdminHeader title={t('leadPreview')} />
      {reportData?.length > 0 ? (
        <Card className="p-0 position-relative">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 180px)' }}>
            {headerFields?.default?.length > 0 ? (
              <table className="report-list-table">
                <thead>
                  <tr className="title">
                    <th colSpan={headerFields?.default?.length}>{t('default')}</th>
                  </tr>
                  <tr>
                    {headerFields?.default?.map((val, index) => {
                      return <th key={index}>{val.label}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {reportData?.map((val, index) => {
                    return (
                      <tr key={index}>
                        {headerFields?.default?.map((value, idx) => {
                          if (value?.name === 'recording_file') {
                            return (
                              <td key={idx} className="text-center cursor-pointer">
                                {val[value?.name] ? (
                                  <Icon.Download
                                    size={16}
                                    onClick={() => {
                                      const link = `${config.BASE_URL}cdrs_report/download?filename=${val[value?.name]}`;
                                      fileDownload(link);
                                    }}
                                  />
                                ) : (
                                  '-'
                                )}
                              </td>
                            );
                          }
                          if (value?.name === 'destination_number') {
                            return (
                              <td key={idx}>
                                {user?.process_details?.numberMasking === 'true'
                                  ? convertToMask(val[value?.name])
                                  : val[value?.name]}
                              </td>
                            );
                          }
                          return <td key={idx}>{val[value?.name] || '-'}</td>;
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : null}
            <table className="report-list-table">
              <thead>
                <tr className="title">
                  <th colSpan={headerFields?.crm_fields?.length}>{t('crm')}</th>
                </tr>
                <tr>
                  {headerFields?.crm_fields?.map((val, index) => {
                    if (val?.name === 'actions') {
                      return (
                        <th key={index} className="text-center" style={{ width: '100px' }}>
                          {val.label}
                        </th>
                      );
                    }
                    return <th key={index}>{val.label}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {reportData?.map((val, index) => {
                  return (
                    <tr key={index}>
                      {headerFields?.crm_fields?.map((value, idx) => {
                        if (value?.name === 'actions') {
                          return (
                            <td key={idx} className="text-center cursor-pointer text-success">
                              <Icon.Phone
                                size={18}
                                onClick={() => {
                                  onPrevieweCall(val);
                                }}
                              />
                            </td>
                          );
                        }
                        if (value?.name === 'destination_number') {
                          return (
                            <td key={idx}>
                              {user?.process_details?.numberMasking === 'true'
                                ? convertToMask(val[value?.name])
                                : val[value?.name]}
                            </td>
                          );
                        }
                        return <td key={idx}>{val[value?.name] || '-'}</td>;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 180px)' }}>
          {t('noDataAvailable')}
        </Card>
      )}
    </div>
  );
};

export default LeadPreview;
